export const EVENTS = {
  CLOSE_CHAT_WINDOW: "close_chat_window",
  AGENT_JOINED: "agentJoined",
  SURVEY_URL: "survey_url",
  DISABLE_INPUT: "disable_input",
  ENABLE_INPUT: "enable_input",
  AGENT_LEFT: "agentLeft",
  CONVERSATION_STARTED: "conversationStarted",
  USER_INTERACTED: "userInteracted",
  CLIENT_INFO: "ClientInfo",
  CLIENT_PLATFORM_INFO: "ClientPlatformInfo",
  CLIENT_CONTEXT_URL: "client_context_url",
  CHAT_CLOSED: "CHAT_CLOSED",
  INITIATE_SIGNIN: "INITIATE_SIGNIN",
  IRIS_HANDOFF_CODE: "handoff_code",
  MESSAGE_REACTION:"messagereaction"
};

export const ACTIONS = {
  INCOMMING_ACTIVITY: "DIRECT_LINE/INCOMING_ACTIVITY",
  POST_ACTIVITY: "DIRECT_LINE/POST_ACTIVITY",
  CONNECTION_FULLFILLED: "DIRECT_LINE/CONNECT_FULFILLED",
};
